<template>
  <footer>
    <div class="footer__cta">
      <div class="footer__cta-left" v-reveal>
        <Image :source="$beet.options.footer.cta.icon" class="image__icon" />
        <h2 class="subtitle">{{ $beet.options.footer.cta.title }}</h2>
      </div>
      <div v-reveal="{ delay: 200 }">
        <p>{{ $beet.options.footer.cta.description }}</p>
        <div class="footer__cta-arrow">
          <ExternalLink
            :link="$beet.options.footer.cta.link"
            :label="$beet.options.footer.cta.label"
            class="--top"
            :arrow="true"
          />
          <Icon id="pointing-arrow" />
        </div>
      </div>
    </div>
    <div class="footer__top">
      <FooterPartners :content="$beet.options.footer.partners" />
      <div class="footer__top-content">
        <Icon id="logo" class="logo footer__top-logo" v-reveal />
        <div class="footer__top-cta" v-reveal="{ delay: 200 }">
          <h2 class="title">{{ $beet.options.footer.contact.title }}</h2>
          <p>{{ $beet.options.footer.contact.description }}</p>
          <ExternalLink
            :link="$beet.options.footer.contact.link"
            :label="$beet.options.footer.contact.label"
            class="--secondary --top"
          />
        </div>
        <div class="footer__top-newsletter" id="contact" v-reveal="{ delay: 250 }">
          <Image
            :source="$beet.options.footer.newsletter.icon"
            class="image__icon footer__top-icon"
          />
          <h3 class="small-title">{{ $beet.options.footer.newsletter.title }}</h3>
        </div>
        <Socials class="footer__top-socials" v-reveal="{ delay: 200 }" />
      </div>
    </div>
    <div class="footer__bottom">
      <div class="footer__bottom-left" v-reveal>
        <p>{{ $beet.options.footer.credits.replace('[YEAR]', '2023') }}</p>
        <LangRouterLink :to="{ name: 'policies' }" :title="$t('policies')">{{
          $t('policies')
        }}</LangRouterLink>
      </div>
      <BeetCredits v-reveal="{ delay: 200 }" />
    </div>
  </footer>
</template>

<script>
import { FooterPartners } from '@/components/blocks'
import { Icon, Image, LangRouterLink } from '@/components/global'
import { BeetCredits, ExternalLink, Socials } from '@/components/small'

export default {
  name: 'SiteFooter',
  components: {
    BeetCredits,
    ExternalLink,
    FooterPartners,
    Icon,
    Image,
    LangRouterLink,
    Socials,
  },
}
</script>
